import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Textbox.css";
/**
 * @desc TextBox
 * @param props
 * @return null
 */

const Textbox = React.forwardRef(props => {
  const { className, label, children, ...other } = props;
  return (
    <div className={"ui-textbox " + className}>
      <label>{label}</label>
      <span className="form-error-message">{children}</span>
      {props.icon ? (
        <div className="textbox__position-right">
          <div className="textbox__icon">
            <img src={props.icon} />
          </div>
          <div className="textbox__content">
            <div className="textbox__wrapper">
              <div className="textbox__content">
                <input type="text" {...other} ref={props.inputRef} className={props.inValid} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <input type="text" {...other} ref={props.inputRef} className={props.inValid} />
      )}
    </div>
  );
})

Textbox.propTypes = {
  /** ClassName will be injected into the component's container. You can use ClassName for adhoc styling. */
  className: PropTypes.string,
  /** The label of the textarea */
  label: PropTypes.string
};

Textbox.defaultProps = {
  className: "",
  label: ""
};

export default Textbox;



// WEBPACK FOOTER //
// ./src/components/UI/Textbox/Textbox.js